$(() => {

  var controller = new ScrollMagic.Controller({globalSceneOptions: {duration: '70%'}});

  new ScrollMagic.Scene({triggerElement: "#section--1"})
    .on("enter", function() {
      $("#section--1 .section__wrapper").removeClass('leaving');
      $("#section--1 .section__wrapper").addClass('showing');
    })
    .on("leave", function() {
      $("#section--1 .section__wrapper").removeClass('showing');
      $("#section--1 .section__wrapper").addClass('leaving');
    })
    .addTo(controller);

  new ScrollMagic.Scene({triggerElement: "#section--2"})
    .on("enter", function() {
      $("#section--2 .section__wrapper").removeClass('leaving');
      $("#section--2 .section__wrapper").addClass('showing');
    })
    .on("leave", function() {
      $("#section--2 .section__wrapper").removeClass('showing');
      $("#section--2 .section__wrapper").addClass('leaving');
    })
    .addTo(controller);

  new ScrollMagic.Scene({triggerElement: "#section--3"})
    .on("enter", function() {
      $("#section--3 .section__wrapper").removeClass('leaving');
      $("#section--3 .section__wrapper").addClass('showing');
    })
    .on("leave", function() {
      $("#section--3 .section__wrapper").removeClass('showing');
      $("#section--3 .section__wrapper").addClass('leaving');
    })
    .addTo(controller);

  new ScrollMagic.Scene({triggerElement: "#section--4"})
    .on("enter", function() {
      $("#section--4 .section__wrapper").removeClass('leaving');
      $("#section--4 .section__wrapper").addClass('showing');
    })
    .on("leave", function() {
      $("#section--4 .section__wrapper").removeClass('showing');
      $("#section--4 .section__wrapper").addClass('leaving');
    })
    .addTo(controller);

});
